<!-- State: Game Component Layout -->
<div class="game-layout">
	<router-outlet />
</div>
